'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var repo = require('ipfs-core-config/repo');

var getDefaultConfig = require('ipfs-core-config/config');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

var PeerId = require('peer-id');

var mergeOpts = require('merge-options');

var profiles = require('./config/profiles.js');

var errors$1 = require('../errors.js');

var libp2p = require('./libp2p.js');

var errors = require('ipfs-repo/errors');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var getDefaultConfig__default = /*#__PURE__*/_interopDefaultLegacy(getDefaultConfig);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:components:peer:storage');

var Storage = /*#__PURE__*/function () {
  function Storage(peerId, keychain, repo, print, isNew) {
    _classCallCheck(this, Storage);

    this.print = print;
    this.peerId = peerId;
    this.keychain = keychain;
    this.repo = repo;
    this.print = print;
    this.isNew = isNew;
  }

  _createClass(Storage, null, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(print, codecs, options) {
        var repoAutoMigrate, inputRepo, onMigrationProgress, repo$1, _yield$loadRepo, peerId, keychain, isNew;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                repoAutoMigrate = options.repoAutoMigrate, inputRepo = options.repo, onMigrationProgress = options.onMigrationProgress;
                repo$1 = typeof inputRepo === 'string' || inputRepo == null ? repo.createRepo(print, codecs, {
                  path: inputRepo,
                  autoMigrate: repoAutoMigrate,
                  onMigrationProgress: onMigrationProgress
                }) : inputRepo;
                _context.next = 4;
                return loadRepo(print, repo$1, options);

              case 4:
                _yield$loadRepo = _context.sent;
                peerId = _yield$loadRepo.peerId;
                keychain = _yield$loadRepo.keychain;
                isNew = _yield$loadRepo.isNew;
                return _context.abrupt("return", new Storage(peerId, keychain, repo$1, print, isNew));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function start(_x, _x2, _x3) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }]);

  return Storage;
}();

var loadRepo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(print, repo, options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (repo.closed) {
              _context2.next = 11;
              break;
            }

            _context2.t0 = _objectSpread;
            _context2.t1 = _objectSpread;
            _context2.t2 = {};
            _context2.next = 6;
            return configureRepo(repo, options);

          case 6:
            _context2.t3 = _context2.sent;
            _context2.t4 = (0, _context2.t1)(_context2.t2, _context2.t3);
            _context2.t5 = {};
            _context2.t6 = {
              isNew: false
            };
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t4, _context2.t5, _context2.t6));

          case 11:
            _context2.prev = 11;
            _context2.next = 14;
            return repo.open();

          case 14:
            _context2.t7 = _objectSpread;
            _context2.t8 = _objectSpread;
            _context2.t9 = {};
            _context2.next = 19;
            return configureRepo(repo, options);

          case 19:
            _context2.t10 = _context2.sent;
            _context2.t11 = (0, _context2.t8)(_context2.t9, _context2.t10);
            _context2.t12 = {};
            _context2.t13 = {
              isNew: false
            };
            return _context2.abrupt("return", (0, _context2.t7)(_context2.t11, _context2.t12, _context2.t13));

          case 26:
            _context2.prev = 26;
            _context2.t14 = _context2["catch"](11);

            if (!(_context2.t14.code !== errors.ERR_REPO_NOT_INITIALIZED)) {
              _context2.next = 30;
              break;
            }

            throw _context2.t14;

          case 30:
            if (!(options.init && options.init.allowNew === false)) {
              _context2.next = 32;
              break;
            }

            throw new errors$1.NotEnabledError('Initialization of new repos disabled by config, pass `config.init.isNew: true` to enable it');

          case 32:
            _context2.t15 = _objectSpread;
            _context2.t16 = _objectSpread;
            _context2.t17 = {};
            _context2.next = 37;
            return initRepo(print, repo, options);

          case 37:
            _context2.t18 = _context2.sent;
            _context2.t19 = (0, _context2.t16)(_context2.t17, _context2.t18);
            _context2.t20 = {};
            _context2.t21 = {
              isNew: true
            };
            return _context2.abrupt("return", (0, _context2.t15)(_context2.t19, _context2.t20, _context2.t21));

          case 42:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[11, 26]]);
  }));

  return function loadRepo(_x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

var initRepo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(print, repo, options) {
    var initOptions, exists, peerId, identity, config, keychainConfig, libp2p$1;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            initOptions = options.init || {};
            _context3.next = 3;
            return repo.exists();

          case 3:
            exists = _context3.sent;
            log('repo exists?', exists);

            if (!(exists === true)) {
              _context3.next = 7;
              break;
            }

            throw new Error('repo already exists');

          case 7:
            if (!initOptions.privateKey) {
              _context3.next = 13;
              break;
            }

            _context3.next = 10;
            return decodePeerId(initOptions.privateKey);

          case 10:
            _context3.t0 = _context3.sent;
            _context3.next = 16;
            break;

          case 13:
            _context3.next = 15;
            return initPeerId(print, initOptions);

          case 15:
            _context3.t0 = _context3.sent;

          case 16:
            peerId = _context3.t0;
            identity = peerIdToIdentity(peerId);
            log('peer identity: %s', identity.PeerID);
            config = _objectSpread(_objectSpread({}, mergeOptions(applyProfiles(getDefaultConfig__default["default"](), initOptions.profiles), options.config)), {}, {
              Identity: identity
            });
            _context3.next = 22;
            return repo.init(config);

          case 22:
            _context3.next = 24;
            return repo.open();

          case 24:
            log('repo opened');
            keychainConfig = {
              pass: options.pass
            };
            _context3.prev = 26;
            _context3.next = 29;
            return repo.config.get('Keychain.DEK');

          case 29:
            keychainConfig.dek = _context3.sent;
            _context3.next = 36;
            break;

          case 32:
            _context3.prev = 32;
            _context3.t1 = _context3["catch"](26);

            if (!(_context3.t1.code !== 'ERR_NOT_FOUND')) {
              _context3.next = 36;
              break;
            }

            throw _context3.t1;

          case 36:
            _context3.next = 38;
            return libp2p.createLibp2p({
              options: undefined,
              multiaddrs: undefined,
              peerId: peerId,
              repo: repo,
              config: config,
              keychainConfig: keychainConfig
            });

          case 38:
            libp2p$1 = _context3.sent;

            if (!(libp2p$1.keychain && libp2p$1.keychain.opts)) {
              _context3.next = 44;
              break;
            }

            _context3.next = 42;
            return libp2p$1.loadKeychain();

          case 42:
            _context3.next = 44;
            return repo.config.set('Keychain', {
              DEK: libp2p$1.keychain.opts.dek
            });

          case 44:
            return _context3.abrupt("return", {
              peerId: peerId,
              keychain: libp2p$1.keychain
            });

          case 45:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[26, 32]]);
  }));

  return function initRepo(_x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

var decodePeerId = function decodePeerId(peerId) {
  log('using user-supplied private-key');
  return typeof peerId === 'object' ? peerId : PeerId__default["default"].createFromPrivKey(fromString.fromString(peerId, 'base64pad'));
};

var initPeerId = function initPeerId(print, _ref3) {
  var _ref3$algorithm = _ref3.algorithm,
      algorithm = _ref3$algorithm === void 0 ? 'Ed25519' : _ref3$algorithm,
      _ref3$bits = _ref3.bits,
      bits = _ref3$bits === void 0 ? 2048 : _ref3$bits;
  print('generating %s keypair...', algorithm);
  return PeerId__default["default"].create({
    keyType: algorithm,
    bits: bits
  });
};

var peerIdToIdentity = function peerIdToIdentity(peerId) {
  return {
    PeerID: peerId.toB58String(),
    PrivKey: toString.toString(peerId.privKey.bytes, 'base64pad')
  };
};

var configureRepo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(repo, options) {
    var config, profiles, pass, original, changed, peerId, libp2p$1;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            config = options.config;
            profiles = options.init && options.init.profiles || [];
            pass = options.pass;
            _context4.next = 5;
            return repo.config.getAll();

          case 5:
            original = _context4.sent;
            changed = mergeConfigs(applyProfiles(original, profiles), config);

            if (!(original !== changed)) {
              _context4.next = 10;
              break;
            }

            _context4.next = 10;
            return repo.config.replace(changed);

          case 10:
            if (!(!changed.Identity || !changed.Identity.PrivKey)) {
              _context4.next = 12;
              break;
            }

            throw new errors$1.NotInitializedError('No private key was found in the config, please intialize the repo');

          case 12:
            _context4.next = 14;
            return PeerId__default["default"].createFromPrivKey(changed.Identity.PrivKey);

          case 14:
            peerId = _context4.sent;
            _context4.next = 17;
            return libp2p.createLibp2p({
              options: undefined,
              multiaddrs: undefined,
              peerId: peerId,
              repo: repo,
              config: changed,
              keychainConfig: _objectSpread({
                pass: pass
              }, changed.Keychain)
            });

          case 17:
            libp2p$1 = _context4.sent;

            if (!libp2p$1.keychain) {
              _context4.next = 21;
              break;
            }

            _context4.next = 21;
            return libp2p$1.loadKeychain();

          case 21:
            return _context4.abrupt("return", {
              peerId: peerId,
              keychain: libp2p$1.keychain
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function configureRepo(_x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

var mergeConfigs = function mergeConfigs(config, changes) {
  return changes ? mergeOptions(config, changes) : config;
};

var applyProfiles = function applyProfiles(config, profiles$1) {
  return (profiles$1 || []).reduce(function (config, name) {
    var profile = profiles.profiles[name];

    if (!profile) {
      throw new Error("Could not find profile with name '".concat(name, "'"));
    }

    log('applying profile %s', name);
    return profile.transform(config);
  }, config);
};

exports.Storage = Storage;